import React, { Component } from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  color: white;
  height: auto;
  background: ${props => props.color};
  background: linear-gradient(to bottom, ${props => props.color} 1%, ${props => props.secondColor} 100%);
`;

class Footer extends Component {
  getYear = () => {
    return new Date().getFullYear();
  };

  render() {
    return (
      <FooterWrapper color={this.props.color} secondColor={this.props.secondColor}>
        <div className="container">
          <div className="row p-2">
            <span className="col-md-6 footer-txt">
              Copyright © {this.getYear()}{' '}
              <span
                className="txt-bold txt-25px txt-uppercase"
                style={{
                  fontSize: 16,
                }}
              >
                GAS
              </span>
              , Tous droits réservés.{' '}
            </span>
            <span className="col-md-6 footer-txt">
              <p>
                Powered by
                <a
                  target="_blank"
                  href="https://tuskens.com"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none', color: 'white' }}
                >
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAACP0lEQVQ4T3VSP2gTURj/fe/d5X9Moo1WzVIFcdFJsommKC4KiuDiUnAIuNRFihbkBgWXKihoseqimwjiavyT2bq4ZVAqwVqVnL1wyV169+7Ju7bXpCTf9Pi+35/vzyOMCClB+Lqn2PUET32v/KFLr8QwKG1P9hbTRzThXifIs0BQCOvEOpBUE6Tf18tuvZ8zIGDWizMczm0JaDr3kdTdQX2CJPDH6ByfpsonP9TeRPx6X5oJhH+3nxHja8glLWhcQErAEzp6fhyOyDwfn1y5Egk0axNHeeB8Uc4qKaVE1/XgewKaxpBOqTTr9wMx/cK+U803YQfL70ovpfQvq/dq28Ff04YQQdQM5wy7d2WQyyajnCT+uXT6Z5mkYbAf5Uctu+vmrbYLt+eNOgx2ZBKhkKZxEEGuxQv7afHF2F7Lbi0HAbDmyZAc0wlMdTwkiIBUIgbbYWhZ8gS9frCzZJtm0+ltoRUomwLG8gTOB1V8H1gxJRwX0HVtkj4aJ7VGr94G5NaAGxxFLhaAzEbFsoGWBahuVaRSuQPhEhdm+VsRiHObXr4A7I46G6BxIJ0E4jqwPuB6EGON6p3gcCjw7Fai4nnuB6WsHJSTunt/JONAPqv2A6g9xzS9Oj3nPYk+0tw1Pv/bFFUx9McPihGjWuagPGMYCCIBw4DW+cYXgkBMjbyj+k6M19L53EXjodkOR9kOvjEVO+/54qaU4lh/nRFrgPN76QnvqXKOdjHKzbhaHHd6/w6RAEskMkvG/OrSMOx/yjzgIePdTqkAAAAASUVORK5CYII="
                    alt="Tuskens"
                    style={{ width: 16, margin: 5 }}
                  />
                  Tuskens.
                </a>
              </p>
            </span>
          </div>
        </div>
      </FooterWrapper>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js